

<template>
    <vuetify-audio :file="file" :ended="audioFinish"></vuetify-audio>
</template>
<script>
import VuetifyAudio from 'vuetify-audio';
import firebase from 'firebase';

export default {
    props:['audioUri'],
    data() {
        return {
            file: '',
            audio:{
                sound: null,
                startTime: 0,
                duration:0
                },
            sound: null
        };
    },
    components: {
        'vuetify-audio': VuetifyAudio
    },
    computed:{
        patientId(){
            return this.$route.params.transcript.patientId
        }
    },
    // If you want to use ended callback add below code
    methods: {
        loadAudio(){
            const me = this;

            if(me.audioUri){
                const soundWavContainer = firebase.storage().ref().child(me.patientId);
                const soundWav = soundWavContainer.child(me.audioUri.split('/').pop());
                soundWav.getDownloadURL().then((url) => { 
                me.file = url;
                me.sound = new Howl({
                  src: [url],
                  onplay: function(){
                    setTimeout(function(){ me.sound.stop();}, me.audio.duration*1000);
                  }
                });
              });
            }
        },
        audioFinish () {
            console.log('You see this means audio finish.');
        },
        playAudio(startTime, duration){
            const me = this;
            me.audio.startTime = startTime;
            me.audio.duration = duration;
            me.sound.seek(startTime);
            me.sound.play();
        }
    },
  mounted (){
      this.loadAudio();
  }
}
</script>

<style>

 .v-btn--icon:before {
    border-radius: 0px!important;
}

.theme--light.v-card {
    background-color: transparent;
    border-color: transparent;
    color: rgba(0,0,0,.87);
    -webkit-box-shadow: none;
    box-shadow: none;
    width:100%;
}

.v-card p{
    height: 30px;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 100;
}

.theme--light.v-card .v-btn--icon{
    border-radius: 0%;
}
.v-slider__track{
    border-bottom: 1px gray solid;
}

.v-card__text {
     padding: 0px!important;
     display: flex;
}

.v-input--slider {
    margin-top: 10px;
    height: 40px;
    flex:1;
    width:100px;
}

.v-slider__thumb.primary{
    background:rgba(95,139,250,.65)!important;
    width:12px;
    height:12px;
}

.teal--text{
        caret-color: #4a6ee0!important;
    color: #4a6ee0!important;
  
}
</style>

